import { connect } from 'react-redux';

import ProjectCreationPage from 'pages/project-creation-page';
import { finishProjectCreation } from 'store/actions/project-creation-actions';

const mapStateToProps = ({ data }) => {
  const { currentUser, opmService } = data;
  return {
    currentUser: currentUser.data,
    stateData: data,
    isOpmDown: opmService?.isServiceDown ?? false,
  };
};

const mapDispatchToProps = {
  finishProjectCreation,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProjectCreationPage);
